<template>
	<v-card class="padding elevation-0" flat>
        <h1 class="fonte">Realizar ligação</h1>
        <p class="black--text">Ligue agora mesmo para quem desejar</p>
        <v-divider mt-3="mt-3"></v-divider>
        <v-layout class="justify-space-between column wrap" style="margin-top:50px;">
            <v-flex md5="md5">
                <v-text-field v-model="ligar.origem" color="blue-grey" box="box" label="Origem" placeholder="(##) #########"></v-text-field>
            </v-flex>
            <v-flex md5="md5">
                <v-text-field v-model="ligar.destino" color="blue-grey" box="box" label="Destino" placeholder="(##) #########"></v-text-field>
            </v-flex>
        </v-layout>
        <v-divider class="mt-5 mb-5"></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round class="white--text" color="error" @click="ligar.origem='',ligar.destino=''">Limpar</v-btn>
            <v-btn round class="white--text" color="fundo" :disabled="!ligar.origem || !ligar.destino" @click="call">Ligar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    //16993338087
	data(){
		return{
			ligar:{
        		origem:'',
        		destino:''
      		}
		}
    },
    methods:{
        ...mapActions(['protaxi_ligar']),
        async call()
        {
            let {origem, destino} = this.ligar
            if(origem == destino)return this.$eventHub.emit('snackBar', { message: 'Origem e destino precisam ser diferentes' })
            origem  = origem.replace(/\D/ig, '').replace(/^0/ig, '')
            destino = destino.replace(/\D/ig, '').replace(/^0/ig, '')

            this.$eventHub.emit('snackBar', {
                message: ( await this.protaxi_ligar({origem, destino}) ) ? 'Aguarde, chamada em curso' : 'Não foi possível realizar chamada'
            })
            this.ligar = { origem:'', destino:'' }
        }
    }
}
</script>


<style lang="stylus">
  .title
    margin-bottom 50px

</style>



// WEBPACK FOOTER //
// src/components/user/protaxi/Ligar.vue